import { UtilityService, UtilityProvider, HttpService } from '@lk/api'

export const makeUtilityService = (http: HttpService, baseUrl: string) =>
  new UtilityService(new UtilityProvider(http, baseUrl))
